import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { styled } from '@activebrands/core-web/libs/styletron';
import PaymentError from 'templates/CheckoutPage/PaymentSection/Payment/PaymentError';
import PaymentMethods from 'templates/CheckoutPage/PaymentSection/Payment/PaymentMethods';

const Wrapper = styled('div');
const Div = styled('div');

const Payment = ({ deliveryStep, checkoutCurrentStep, paymentStep, ...rest }) => {
    const basket = useSelector(state => state.basket);
    const { paymentError, paymentMethodId, paymentMethods, cloudflareTurnstileStatus } = basket;
    const cloudflareTurnstileNeedsAction = cloudflareTurnstileStatus === 'need action';
    const paymentErrorRef = useRef(null);

    useEffect(() => {
        if (paymentError && paymentErrorRef?.current) {
            scrollTo({
                smooth: true,
                top: paymentErrorRef.current.offsetTop - 90,
            });
        }
    }, [paymentError]);

    return (
        <Wrapper {...rest}>
            {paymentError && <PaymentError error={paymentError} paymentErrorRef={paymentErrorRef} />}
            {checkoutCurrentStep === paymentStep && (
                <Div
                    $style={{
                        display: cloudflareTurnstileNeedsAction ? 'flex' : 'none',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '24px',
                    }}
                    id="cloudflare-turnstile-widget"
                />
            )}
            {checkoutCurrentStep >= deliveryStep && (
                <PaymentMethods paymentMethodId={paymentMethodId} paymentMethods={paymentMethods} />
            )}
        </Wrapper>
    );
};

Payment.propTypes = {
    checkoutCurrentStep: PropTypes.number.isRequired,
    deliveryStep: PropTypes.number.isRequired,
    paymentStep: PropTypes.number.isRequired,
};

export default Payment;
